import { type MCPServerInfo } from '../../types';

const LinxServer: MCPServerInfo = {
  serverId: 'LINX',
  name: 'Linx',
  slug: 'linx',
  description: 'Linx MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.linxsecurity.io/mcp-service/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default LinxServer;
